import { 
    RESET_PASSWORD_SEND_EMAIL_START_ACTION, 
    RESET_PASSWORD_SEND_EMAIL_COMPLETE_ACTION, 
    RESET_PASSWORD_SEND_EMAIL_FAILED_ACTION,
    RESET_PASSWORD_START_ACTION,
    RESET_PASSWORD_COMPLETE_ACTION,
    RESET_PASSWORD_FAILED_ACTION
} from "./ResetPasswordActions";

const initialState = {
    requestCodeDone: false,
    requestResetPasswordDone: false
};

const resetPasswordReducer = (state = initialState, action) => {
    switch(action.type) {
        case RESET_PASSWORD_SEND_EMAIL_START_ACTION: {
            return {
                ...state,
                requestCodeDone: false
            };
        }
        case RESET_PASSWORD_SEND_EMAIL_COMPLETE_ACTION: {
            return {
                ...state,
                requestCodeDone: true
            };
        }
        case RESET_PASSWORD_SEND_EMAIL_FAILED_ACTION: {
            return {
                ...state,
                requestCodeDone: false
            };
        }
        case RESET_PASSWORD_START_ACTION: {
            return {
                ...state,
                requestResetPasswordDone: false
            };
        }
        case RESET_PASSWORD_COMPLETE_ACTION: {
            return {
                ...state,
                requestResetPasswordDone: true
            };
        }
        case RESET_PASSWORD_FAILED_ACTION: {
            return {
                ...state,
                requestResetPasswordDone: false
            };
        }
        default:
            return state;
    }
};

export default resetPasswordReducer;


// WEBPACK FOOTER //
// ./src/features/common/login/reset-password-form/ResetPasswordReducer.jsx